import { getSpline } from '../util';
import PathMask from './path';

/**
 * Smooth path mask
 * @ignore
 */
class SmoothPathMask extends PathMask {
  // çæ mask çè·¯å¾
  protected getMaskPath() {
    const points = this.points;
    return getSpline(points, true);
  }
}

export default SmoothPathMask;
